import React from "react";
import { Helmet } from "react-helmet-async";
import { FaGraduationCap, FaCar, FaChalkboardTeacher, FaChartLine, FaUserCheck, FaRoad } from "react-icons/fa";

import {
  Container,
  Hero,
  Photo,
  PhotoPlaceholder,
  HeroText,
  SmallTitle,
  Title,
  Subtitle,
  Paragraph,
  SectionTitle,
  Grid,
  Card,
  Icon,
  CardTitle,
  CardText,
  Quote,
  Center,
} from "./about/About.styles";

import profileImage from "../PhotosGallery/jangin.jpg";
import { useTranslation } from "react-i18next";


const About: React.FC = () => {
  const { t, i18n } = useTranslation();
  const cards = t("about.cards", { returnObjects: true }) as string[][];

  return (

    <>

      <Helmet>

        <title>
          {t("about.seoTitle")}
        </title>


        <meta
          name="description"
          content={t("about.seoDescription")}
        />


        <meta
          name="keywords"
          content="rijinstructeur Oost-Souburg, Best Rijschool, rijlessen Zeeland, rijbewijs halen, rijopleiding"
        />

      </Helmet>



      <Container>


        <Hero>


          {profileImage ? (

            <Photo
              src={profileImage}
              alt={t("about.imageAlt")}
            />

          ) : (

            <PhotoPlaceholder>

              {t("about.photoPlaceholder")}

            </PhotoPlaceholder>

          )}




          <HeroText>


            <SmallTitle>
              {t("about.smallTitle")}
            </SmallTitle>


            <Title>
              {i18n.language === "ar" ? "جانكين شيخو" : "Jangin Shekho"}
            </Title>


            <Subtitle>
              {t("about.subtitle")}
            </Subtitle>



            <Paragraph>

              {t("about.p1")}

            </Paragraph>


            <Paragraph>

              {t("about.p2")}

            </Paragraph>


          </HeroText>


        </Hero>





        <Paragraph>

          {t("about.p3")}

        </Paragraph>



        <Paragraph>

          {t("about.p4")}

        </Paragraph>





        <SectionTitle>

          {t("about.why")}

        </SectionTitle>




        <Grid>
          {[FaChalkboardTeacher, FaGraduationCap, FaCar, FaChartLine, FaUserCheck, FaRoad].map((CardIcon, index) => <Card key={index}><Icon><CardIcon /></Icon><CardTitle>{cards[index][0]}</CardTitle><CardText>{(i18n.language === "ar" && index === 5 ? "ليس النجاح فقط، بل المشاركة بأمان في القيادة في الطريق" : cards[index][1]).replace(/[.۔]$/, "")}</CardText></Card>)}



        </Grid>





        <Quote>


          <p>

            &quot;{t("about.quote")}&quot;

          </p>


        </Quote>





        <Center>




        </Center>




      </Container>


    </>

  );

};


export default About;
